var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Vyberte brokera")]), _c('button', {
    staticClass: "w-button saveformBtn",
    attrs: {
      "form": "amounts-submit"
    }
  }, [_vm._v("Uložiť")])]), _c('form', {
    attrs: {
      "id": "amounts-submit"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveAmounts.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.amounts.suma_nadobudnutie,
      expression: "amounts.suma_nadobudnutie",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "max": _vm.limits.suma_nadobudnutie,
      "min": "0",
      "type": "number",
      "step": "0.01",
      "name": "nadobudnutie",
      "data-name": "nadobudnutie",
      "required": "",
      "id": "nadobudnutie"
    },
    domProps: {
      "value": _vm.amounts.suma_nadobudnutie
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.amounts, "suma_nadobudnutie", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('div', {
    staticClass: "max-button"
  }, [_c('span', {
    staticClass: "pop-600 bl-color copy-text pointer noselect pointer",
    on: {
      "click": function click($event) {
        _vm.amounts.suma_nadobudnutie = _vm.limits.suma_nadobudnutie;
      }
    }
  }, [_vm._v(" MAX ")])])]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.amounts.suma_refinancovanie,
      expression: "amounts.suma_refinancovanie",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "max": _vm.limits.suma_refinancovanie,
      "min": "0",
      "type": "number",
      "step": "0.01",
      "name": "refinancovanie",
      "data-name": "refinancovanie",
      "required": "",
      "id": "refinancovanie"
    },
    domProps: {
      "value": _vm.amounts.suma_refinancovanie
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.amounts, "suma_refinancovanie", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('div', {
    staticClass: "max-button"
  }, [_c('span', {
    staticClass: "pop-600 bl-color copy-text pointer noselect",
    on: {
      "click": function click($event) {
        _vm.amounts.suma_refinancovanie = _vm.limits.suma_refinancovanie;
      }
    }
  }, [_vm._v(" MAX ")])])]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.amounts.suma_bezucel,
      expression: "amounts.suma_bezucel",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "max": _vm.limits.suma_bezucel,
      "min": "0",
      "type": "number",
      "step": "0.01",
      "name": "zakladDane",
      "data-name": "zakladDane",
      "required": "",
      "id": "zakladDane"
    },
    domProps: {
      "value": _vm.amounts.suma_bezucel
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.amounts, "suma_bezucel", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('div', {
    staticClass: "max-button"
  }, [_c('span', {
    staticClass: "pop-600 bl-color copy-text pointer noselect",
    on: {
      "click": function click($event) {
        _vm.amounts.suma_bezucel = _vm.limits.suma_bezucel;
      }
    }
  }, [_vm._v(" MAX ")])])])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "nadobudnutie"
    }
  }, [_vm._v("Suma "), _c('strong', [_vm._v("nadobudnutie")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "refinancovanie"
    }
  }, [_vm._v("Suma "), _c('strong', [_vm._v("refinancovanie")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "zakladDane"
    }
  }, [_vm._v("Suma "), _c('strong', [_vm._v("bezúčel")])]);

}]

export { render, staticRenderFns }